import React from 'react';

interface LogoProps {
  variant?: 'light' | 'dark';
}

export const Logo = ({ variant = 'dark' }: LogoProps) => {
  const logoPath = variant === 'light' 
    ? '/lovable-uploads/5ec2743f-e342-498f-a206-0c1dabf8bf22.png'
    : '/lovable-uploads/56de7965-fc24-490a-b6df-287889fcf480.png';

  return (
    <div className="w-24">
      <img 
        src={logoPath} 
        alt="Digs" 
        className="w-full h-auto"
      />
    </div>
  );
};